import React , {Component} from 'react';
import * as vars from "./../Vars";
import * as axios from "axios/index";
import validator from "validator";
import mapboxgl from "mapbox-gl";

import backIcon from './../../assets/images/icons/back-2.svg';
import mapIcon from './../../assets/images/icons/map.svg';
import mapIcon2 from './../../assets/images/icons/map-2.svg';
import flagIcon from './../../assets/images/icons/flag.svg';
import { Modal } from 'react-bootstrap';

class AddressSingleMapIr extends Component{
    constructor(props){

        super(props)
        this.state = {
            inPageLoading : false ,


            latitude: 37.28115563160914 ,
            longitude: 49.58400249481201 ,


            selectedLatitude: 37.28115563160914 ,
            selectedLongitude: 49.58400249481201 ,


            addressModal : false,
            addressError : null ,
            errors : {} ,
            fields : {
                title : "" ,
                body : "" ,

            } ,

            updateAddress : false
        }
    }


    componentDidMount(){

        this.setState({
            latitude: this.props.address.latitude ,
            longitude: this.props.address.longitude ,

            selectedLatitude: this.props.address.latitude ,
            selectedLongitude: this.props.address.longitude ,
            fields : {
                title : this.props.address.title ,
                body : this.props.address.body ,

            } ,
        })
    }
    removeHandler()
    {
        const {address} = this.props
        this.setState({
            inPageLoading : true ,
        })
        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        axios.post(vars.Url +'api/v1/address/destroy/' + address.id , data , {
            params : {
            }

        } )
        .then(response => {
            let data = response.data.data
            // console.log(data)
            this.setState({
                inPageLoading : false ,
            })
            this.props.onRemoveHandler(address.id)
        })
        .catch( (error) => {
            let data = error.response.data.data
            this.setState({
                inPageLoading : false ,
            })
        })
    }


    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }
    addressModalHideHandler(){
        this.setState({
            addressModal : false
        })
    }

    addressSubmitHandler(){
        let { fields } = this.state
        let errors = {}
        let formValid = true
        if ( fields.title === null || validator.isEmpty(fields.title))
        {
            formValid = false;
            errors['title'] = 'عنوان را وارد کنید';
        }
        else if(! validator.isLength(fields.title , { min : 2}))
        {
            formValid = false;
            errors['title'] = 'عنوان حداقل باید 2 حرف باشد';
        }

        if ( fields.body === null || validator.isEmpty(fields.body))
        {
            formValid = false;
            errors['body'] = 'آدرس دقیق خود را وارد کنید';
        }
        else if(! validator.isLength(fields.body , { min : 5}))
        {
            formValid = false;
            errors['body'] = 'آدرس حداقل باید 5 حرف باشد';
        }

        if (formValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }


        this.setState({
            inPageLoading : true
        })

        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        data.append('title' , this.state.fields.title )
        data.append('body' , this.state.fields.body )
        data.append('latitude' , this.state.selectedLatitude )
        data.append('longitude' , this.state.selectedLongitude )

        axios.post(vars.Url +'api/v1/address/update/' + this.props.address.id , data , {
            params : {
            }

        } )
        .then((response) => {
            let data = response.data.data
            this.setState({
                inPageLoading : false ,
                addressModal : false ,
                updateAddress : false ,
            })
            this.props.onUpdateHandler(data.address)

        })
        .catch( (error) => {
            let data = error.response.data.data
            this.setState({
                inPageLoading : false ,
                addressError : data.message ,
            })
        })

    }


    componentDidUpdate(prevProps, prevState){


        if (prevState.updateAddress !== this.state.updateAddress)
        {
            const map = new mapboxgl.Map({
                container: 'map-' + this.props.thisId ,
                style: `https://map.ir/vector/styles/main/mapir-xyz-style.json?x-api-key=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImQ2NGMzMmVhZDkxNDlmZjA4YzBmODI5OTE0NTY0MTQ3NzNkNTNjZWY5ZjRhODk2Y2M5OTY4MWM2M2EzMjkyZTZhMzI1N2E4YjYxZGU3YzM2In0.eyJhdWQiOiIyMzk0OCIsImp0aSI6ImQ2NGMzMmVhZDkxNDlmZjA4YzBmODI5OTE0NTY0MTQ3NzNkNTNjZWY5ZjRhODk2Y2M5OTY4MWM2M2EzMjkyZTZhMzI1N2E4YjYxZGU3YzM2IiwiaWF0IjoxNjkzNjQ2Mjg3LCJuYmYiOjE2OTM2NDYyODcsImV4cCI6MTY5NjIzODI4Nywic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.ngYU1DK3SNoWpoXkrRqVT_Cbzbs4ssLnFSIaPj0VnjRvq-7bNSMKQUKScBn5qH_bjt8u_X8C0QHr0Y8viHSsZq8nfutUeycvtlFk7Y8OMhYmuU6PPI1e98nH4LrnXP1c58u0RDs9C2xBcTj5luK4BNutyLsxf2unPjMoSEzEqe5XszV87ugi5DZQMYeldGE3s_yASlUHTY2Ga81X4PUP65EQKkl70y95e1UoW-ALR00Jqd2jBHyO6mO6ihnLt0YIMXj3pE9kNj5wp6hoPPBnkHN-lC2bIqd0h__tNWc9NYGOSf9iG5nO19ptUmwVdEnSU6-AMb7W-88wxsnP0VYGxg`,
                center: [this.state.longitude, this.state.latitude],
                zoom: 15,
                transformRequest: (url) => {
                    return {
                        url,
                        headers: {
                            'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImQ2NGMzMmVhZDkxNDlmZjA4YzBmODI5OTE0NTY0MTQ3NzNkNTNjZWY5ZjRhODk2Y2M5OTY4MWM2M2EzMjkyZTZhMzI1N2E4YjYxZGU3YzM2In0.eyJhdWQiOiIyMzk0OCIsImp0aSI6ImQ2NGMzMmVhZDkxNDlmZjA4YzBmODI5OTE0NTY0MTQ3NzNkNTNjZWY5ZjRhODk2Y2M5OTY4MWM2M2EzMjkyZTZhMzI1N2E4YjYxZGU3YzM2IiwiaWF0IjoxNjkzNjQ2Mjg3LCJuYmYiOjE2OTM2NDYyODcsImV4cCI6MTY5NjIzODI4Nywic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.ngYU1DK3SNoWpoXkrRqVT_Cbzbs4ssLnFSIaPj0VnjRvq-7bNSMKQUKScBn5qH_bjt8u_X8C0QHr0Y8viHSsZq8nfutUeycvtlFk7Y8OMhYmuU6PPI1e98nH4LrnXP1c58u0RDs9C2xBcTj5luK4BNutyLsxf2unPjMoSEzEqe5XszV87ugi5DZQMYeldGE3s_yASlUHTY2Ga81X4PUP65EQKkl70y95e1UoW-ALR00Jqd2jBHyO6mO6ihnLt0YIMXj3pE9kNj5wp6hoPPBnkHN-lC2bIqd0h__tNWc9NYGOSf9iG5nO19ptUmwVdEnSU6-AMb7W-88wxsnP0VYGxg',
                            'Mapir-SDK': 'reactjs'
                        }
                    }
                }
            });


            const marker = new mapboxgl.Marker({
                draggable: true
            })
                .setLngLat([this.state.selectedLongitude, this.state.selectedLatitude])
                .addTo(map)



            marker.on('dragend', () => {
                let lngLat = marker.getLngLat()
                this.setState({
                    selectedLatitude: lngLat.lat ,
                    selectedLongitude: lngLat.lng ,
                })
            });

            map.on('move', () => {
                this.setState({
                    selectedLatitude: map.getCenter().lat ,
                    selectedLongitude: map.getCenter().lng ,

                    longitude: map.getCenter().lng ,
                    latitude: map.getCenter().lat ,
                })
                marker.setLngLat([map.getCenter().lng, map.getCenter().lat])
            })



            map.on('click', (e) => {
                this.setState({
                    selectedLatitude: e.lngLat.lat ,
                    selectedLongitude: e.lngLat.lng ,


                    longitude: e.lngLat.lng ,
                    latitude: e.lngLat.lat ,
                })
                marker.setLngLat([e.lngLat.lng, e.lngLat.lat])
            })
        }
    }


    updateHandler(){
        this.setState({
            updateAddress : !this.state.updateAddress
        })
    }

    render(){
        const {address} = this.props
        const {errors} = this.state
        return(
            <div>
                <div id="in-page-loading" className={(this.state.inPageLoading === true ? "show" : "")}>
                    <div className="content-container">
                        <div className="text-center mb-3">
                            <i className="fas fa-circle-notch fa-spin item-icon" />
                        </div>
                        <div className="title">
                            لطفا شکیبا باشید
                        </div>
                    </div>
                </div>

                <div className="card-custom-17" >
                    <div className="title">
                        {address.title}
                    </div>
                    <div className="body">
                        {address.body}
                    </div>
                    <div className="row no-gutters justify-content-between mt-4">
                        <div className="col-auto">
                            <div className="item-action" onClick={this.updateHandler.bind(this)}>
                                ویرایش
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="item-action" onClick={this.removeHandler.bind(this)}>
                                حذف
                            </div>
                        </div>
                    </div>
                </div>





                <div id="update-address" className={(this.state.updateAddress === true ? "show" : "")}>


                    <div className="text-decoration-none">
                        <header className="header-3">
                            <div className="container p-0">
                                <div className="row no-gutters justify-content-center">
                                    <div className="col-lg-6">
                                        <div className="items-container">
                                            <div className="row justify-content-between">
                                                <div className="col-auto">
                                                    <span onClick={this.updateHandler.bind(this)}>
                                                        <span>
                                                            <img src={backIcon} alt="back" className="item-icon" />
                                                        </span>
                                                    </span>

                                                    <span className="title">
                                                    ویرایش آدرس
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>

                        <div className="container p-0 mt-5">
                            <div className="row no-gutters justify-content-center">
                                <div className="col-lg-6">
                                    <div className="items-container items-container-custom-1">
                                        <div className="row justify-content-between align-items-center">
                                            <div className="col-auto">
                                                <div className="title-custom-2">
                                                    <img src={mapIcon} alt="back" className="item-icon" />
                                                    <span className="title">
                                                    مکان تحویل خود را روی نقشه انتخاب کنید.
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="map-container">

                            <div className="container p-0  h-100">
                                <div className="row no-gutters justify-content-center h-100">
                                    <div className="col-lg-6 h-100">
                                        <div className="items-container h-100">
                                            <div id={"map-" + (this.props.thisId)} />

                                            <div id="btn-item-container">
                                                <button className="btn btn-custom-5 btn-block " onClick={() => this.setState({addressModal : true})}>
                                                    ادامه
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>




                    <Modal
                        show={this.state.addressModal}
                        onHide={this.addressModalHideHandler.bind(this)}
                        className="bottom-sheet modal-custom-2" centered>

                        <Modal.Body>


                            <div id="in-page-loading" className={(this.state.inPageLoading === true ? "show" : "")}>
                                <div className="content-container">
                                    <div className="text-center mb-3">
                                        <i className="fas fa-circle-notch fa-spin item-icon" />
                                    </div>
                                    <div className="title">
                                        لطفا شکیبا باشید
                                    </div>
                                </div>
                            </div>


                            <div className="title">
                                جزئیات آدرس
                            </div>
                            <div>
                                {
                                    this.state.addressError !== null ?
                                        (
                                            <div className="alert alert-danger mt-2">
                                                {this.state.addressError}
                                            </div>
                                        )
                                        :
                                        (``)
                                }
                            </div>

                            <div className="mt-5">
                                <div className="content-custom-1">
                                    لطفا آدرس دقیق خود را وارد کنید
                                </div>
                            </div>
                            <div  className="mt-3">
                                <div className="form-group form-group-custom-1">
                                <textarea
                                    placeholder="آدرس دقیق"
                                    name="body"
                                    className={["form-control form-control-custom-1" , errors['body'] ? 'is-invalid' : ''].join(' ')}
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.fields.body}
                                    rows={3}
                                />
                                    <span className={["invalid-feedback" ,  errors['body'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['body'] }</span>
                                    <img src={mapIcon2} alt="map" className="item-icon" />
                                </div>

                            </div>


                            <div className="mt-4">
                                <div className="content-custom-1">
                                    لطفا یک عنوان برای آدرستان انتخاب کنید
                                </div>
                            </div>
                            <div  className="mt-3">
                                <div className="form-group form-group-custom-1">
                                    <input
                                        type="text"
                                        className={["form-control form-control-custom-1" , errors['title'] ? 'is-invalid' : ''].join(' ')}
                                        name="title"
                                        onChange={this.handleChange.bind(this)}
                                        placeholder=" مثل «خانه» ، «محل کار»، و ..."
                                        value={this.state.fields.title}  />
                                    <span className={["invalid-feedback" ,  errors['title'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['title'] }</span>
                                    <img src={flagIcon} alt="flag" className="item-icon" />
                                </div>

                            </div>
                            <div className="mt-5">
                                <button className="btn btn-block btn-custom-3" onClick={this.addressSubmitHandler.bind(this)}>
                                    ثبت
                                </button>
                            </div>



                        </Modal.Body>
                    </Modal>

                </div>

            </div>

        )
    }
}
export default AddressSingleMapIr;